import { motion } from 'framer-motion';
import { FaBullseye, FaEye, FaHandshake } from 'react-icons/fa';
import { IMG } from '../../data/siteData';
import './About.css';

const TIMELINE = [
  { year: '2010', title: 'One Truck, One Route', desc: 'Ambadykannan Transport begins with a single truck running goods between Erode and Kochi.' },
  { year: '2018', title: 'Fleet Expansion', desc: 'Lorry fleet added to serve construction and industrial clients across Tamil Nadu.' },
  { year: '2024', title: 'Cross-State Freight', desc: 'Long-distance freight corridors open across Kerala, backed by GPS-tracked dispatch.' },
  { year: 'Today', title: '5000+ Deliveries Strong', desc: 'A trusted heavy transport partner for industrial, construction, and commercial logistics.' },
];

const VALUES = [
  { icon: FaBullseye, title: 'Mission', desc: 'Move every consignment safely, on schedule, and without excuses.' },
  { icon: FaEye, title: 'Vision', desc: 'To be the most dependable heavy transport network across South India.' },
  { icon: FaHandshake, title: 'Values', desc: 'Punctuality, transparency, and respect for every driver and client.' },
];

export default function AboutFull() {
  return (
    <>
      <section className="section">
        <div className="container about-intro__grid">
          <div
            className="about-intro__media"
            initial={{ opacity: 0, scale: 1.05 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 1 }}
          >
            <img src={IMG.warehouse} alt="Ambadykannan Transport loading yard" loading="lazy" />
          </div>

          <div>
            <p className="eyebrow">Company Story</p>
            <h2 className="section-title">Two Decades On<br />The Highway.</h2>
            <p>
              What began as one driver and one truck on the Erode–Kochi corridor has grown
              into a full-scale transport company serving industrial, construction, and
              commercial clients across Kerala and Tamil Nadu.
            </p>

            <div className="timeline">
              {TIMELINE.map((t, i) => (
                <div
                  className="timeline__item"
                  key={t.year}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, margin: '-60px' }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                >
                  <span className="timeline__dot" />
                  <span className="timeline__year">{t.year}</span>
                  <h4>{t.title}</h4>
                  <p>{t.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="section section-alt">
        <div className="container">
          <p className="eyebrow">Why Choose Us</p>
          <h2 className="section-title">Mission, Vision<br />&amp; Values.</h2>

          <div className="values-grid">
            {VALUES.map((v, i) => (
              <motion.div
                className="value-card glass"
                key={v.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
              >
                <v.icon />
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
